import React from 'react';
import { useNavigate } from 'react-router-dom';
import CancelMakeUpSessionPage from './CancelMakeUpSessionPage';

const CancelMakeUpSessionPageWrapper = () => {
  const navigate = useNavigate();
  
  return <CancelMakeUpSessionPage navigate={navigate} />;
};

export default CancelMakeUpSessionPageWrapper;
